export default {"src":"/_next/static/media/GOLD.a2ada48e.svg","height":18,"width":18};